import React from "react";
import DOMPurify from "dompurify";

/**
 * HtmlRenderer Component
 *
 * Renders sanitized HTML content safely and ensures links open in a new tab.
 */
const HtmlRenderer = ({ html }) => {
  // Allow target and rel so DOMPurify doesn't strip them
  const cleanHtml = DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel"],
  });

  return (
    <div
      className="prose max-w-none ql-editor"
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default HtmlRenderer;
